import { memo } from "react";
import { Badge, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { VideoCameraFront, VideocamOff } from "@mui/icons-material";
import { useViewContext } from "@/contexts/ViewContext";
import { useTeleconsultoriaPresenceState } from "./TeleconsultoriaPresenceContext";

/**
 * Atalho do header: um clique liga/desliga a disponibilidade de teleconsultoria.
 * Só aparece para profissional (papel practitioner) da organização prestadora.
 * Ponto verde = disponível (online para convites e "Atender agora").
 */
export const TeleconsultoriaAvailabilityHeaderToggle = memo(
  function TeleconsultoriaAvailabilityHeaderToggle() {
    const { availableRoles } = useViewContext();
    const { canManageAvailability, isAvailable, isLoading, isSaving, setAvailable } =
      useTeleconsultoriaPresenceState();
    const isPractitioner = Boolean(availableRoles?.includes("practitioner"));
    if (!canManageAvailability || !isPractitioner) return null;

    const label = isAvailable
      ? "Teleconsultoria: disponível (clique para ficar indisponível)"
      : "Teleconsultoria: indisponível (clique para ficar disponível)";
    const isBusy = isLoading || isSaving;

    return (
      <Tooltip title={label}>
        <span>
          <IconButton
            color="inherit"
            aria-label={label}
            aria-pressed={isAvailable}
            disabled={isBusy}
            onClick={() => void setAvailable(!isAvailable)}
            sx={{ mr: 0.5 }}
          >
            {isBusy ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <Badge
                variant="dot"
                color="success"
                invisible={!isAvailable}
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                {isAvailable ? <VideoCameraFront /> : <VideocamOff sx={{ opacity: 0.7 }} />}
              </Badge>
            )}
          </IconButton>
        </span>
      </Tooltip>
    );
  },
);
